/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 判断文件是否存在
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class IsFileExistParams {
  constructor(public filePath: string) {}
}

export default async function (
  params: IsFileExistParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/oss/hasFile`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
